export default {
    nav: {
        user: {
            appearance          : "Darstellung",
            user                : "Benutzer",
            roles               : "Rollen",
            dataadmin           : "Administration Ereignisse",
            permanentmenu       : "Menüs einblenden",
            editterminated      : "Abgeschlossene Ereignisse bearbeiten",
            restoreincidents    : "Gelöschte Ereignisse wieder herstellen",
            restorenotices      : "Notizen wieder herstellen",
            smallimages         : "Kleinere Bilder in der Vorschau",
            useimagecache       : "VGA Cache für Bilder verwenden",
            logout              : "Abmelden",
            docdetails          : "Details in der Dokumentenanzeige",
            dmsdisplaymode      : "Dokumente einblenden",
            noticedisplaymode   : "Notizen immer einblenden",
            memorygadget        : "Speicherauslastung anzeigen",
            lgsstate            : "Liftguardian Smart Status anzeigen",
            hints: {
                dataadmin        : "Ereignisse und Meldungen löschen, Ereignistyp ändern, ...",
                permanentmenu    : "Menüs auf der linken Seite werden permanet eingeblendet ...",
                editterminated   : "Abgeschlossene Ereignisse können bearbeitet werden ...",
                restoreincidents : "Gelöschte Ereignisse können wieder  hergestellt werden ...",
                restorenotices   : "Gelöschte Notizen nach Löschung wieder sichtbar machen ...",
                smallimages      : "Die Größe der Bilder in der Vorschau für Anlagen festlegen ...",
                useimagecache    : "VGA Cache zur schnelleren Anzeige der Bilder verwenden ...",
                docdetails       : "Dokumentenlists in Ereignissen kompakt oder detailiert darstellen...",
                dmsdisplaymode   : "Dokumente werden innerhalb des Browserfensters angezeigt ...",
                noticedisplaymode: "Notizen werden auch bei Reparaturen immer einblenden",
                memorygadget     : "Die Speicherauslastung wird angezeigt und regelmäßig aktualisiert.",
                lgsstate         : "Der Liftgardian Smart Status wird angezeigt und regelmäßig aktualisiert.",
            },
            message: {
                exchange: "Die Exchange Synchronisation wurde gestartet",
                reload  : "Die Auswahlisten werden neu geladen",
                syncdms : "Die DMS Synchronisation wurde gestartet",
            }
        }
    },
}